import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dark text-white py-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-sm text-gray-400">
              CopyRight © 2025 北京引力结构信息技术有限公司
            </p>
          </div>
          
          <div className="mb-4 md:mb-0">
            <a 
              href="https://beian.miit.gov.cn/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-sm text-gray-400 hover:text-gray-300 transition-colors"
            >
              京ICP备2025124571号-3
            </a>
          </div>
          
          <div className="text-sm text-gray-400">
            公司地址：北京市大兴区宏业东路2号院1号楼3层1264
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 